import React from 'react'
import { makeStyles, createMuiTheme, MuiThemeProvider, withStyles } from "@material-ui/core/styles";
import { Card, CardContent, Typography, Chip, Dialog, DialogTitle, DialogContent, Divider, Grid, Button, DialogActions, Tooltip, IconButton, Checkbox, TextField, Select, MenuItem, FormControlLabel } from '@material-ui/core';
import MUIDataTable, { TableFilterList } from "mui-datatables";
import MUIDataTableHead from '../custom/MUIDataTableHead'
import MUIDataTableToolbarSelect from '../custom/MUIDataTableToolbarSelect';
import IAMAction from '../../actions/IAMAction';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CachedIcon from '@material-ui/icons/Cached';
import CheckIcon from '@material-ui/icons/Check';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close'
import PersonIcon from '@material-ui/icons/Person';
import PeopleIcon from '@material-ui/icons/People';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import BlockIcon from '@material-ui/icons/Block';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import AddBoxRoundedIcon from '@material-ui/icons/AddBoxRounded';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import { green, blue } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
    rootDesktop: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
    rootTablet: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(5),
        marginRight: theme.spacing(5),
    },
    rootMobile: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    editButtonMobile: {
        position: 'absolute',
        right: theme.spacing(6),
        top: theme.spacing(1.5),
        color: theme.palette.grey[500],
    },
    saveButtonMobile: {
        position: 'absolute',
        right: theme.spacing(11),
        top: theme.spacing(1.5),
        color: theme.palette.grey[500],
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1.5),
        color: theme.palette.grey[500],
    },
}));

const getMuiTheme = (theme) => createMuiTheme({
    ...theme,
    overrides: {
        ...theme.overrides,
        MUIDataTableFilter: { root: { backgroundColor: theme.palette.background.secondary } },
    },
});

const CustomCheckbox = withStyles({ root: { color: blue[400], '&$checked': { color: green[600] } }, checked: {} })((props) => <Checkbox color="default" {...props} />);

const UserDialog = withStyles({ root: {} })(Dialog)

const BulkActionDialog = withStyles({ root: {} })(Dialog)

const MenuProps = { PaperProps: { style: { backgroundColor: "#424242", maxHeight: 500, minWidth: 100, maxWidth: 350 } } };

const userTemplate = {
    access: "",
    accesslvl: "",
    accounttype: "",
    additional_info: {
        SupportNameCode: "UNASSIGNED",
        SupportOptions: [],
    },
    approval__date: "",
    approved: 0,
    company: "",
    contact_number: "",
    customer: "",
    email: "",
    fname: "",
    islocked: "",
    last_logged_in: "",
    lname: "",
    manager_email: "",
    manager_name: "",
    registration_date: "",
    twofactor: "",
    update_date: "",
    username: "",
}
const Usermanagement = ({ profile, responsive }) => {
    const classes = useStyles()
    const [metadata, setMetadata] = React.useState({ data: { companyList: [], customerList: [], managers: [], accounttypes: {}, b2bSupportConfig: [] }, status: "NEW" })
    const [users, setUsers] = React.useState({ 'status': 'NEW', data: [], 'reason': '' })
    const [selectedRow, _setSelectedRow] = React.useState(userTemplate);
    const [bulkActionDialog, setBulkActionDialog] = React.useState({ data: [] })
    const [actionStatus, setActionStatus] = React.useState('NEW')
    const [userEditModeOn, setUserEditModeOn] = React.useState(false)
    const [userEditModeForm, _setUserEditModeForm] = React.useState(userTemplate)
    const [addCustomer, setAddCustomer] = React.useState({ open: false, customer: "", status: "NEW" })

    const setSelectedRow = (data) => {
        _setSelectedRow({ ...userTemplate, ...data, additional_info: { ...userTemplate.additional_info, ...data.additional_info } })
    }

    const setUserEditModeForm = (data) => {
        _setUserEditModeForm({ ...userTemplate, ...data, additional_info: { ...userTemplate.additional_info, ...data.additional_info } })
    }

    const updateUserEditModeForm = (key, value) => {
        if (key === "supportNameCode") {
            setUserEditModeForm({ ...userEditModeForm, additional_info: { ...userEditModeForm.additional_info, SupportNameCode: value } })
        } else if (key === "SupportOptions") {
            var addInfo = userEditModeForm.additional_info
            if (addInfo.SupportOptions.includes(value)) {
                var newSupportOptions = []
                addInfo.SupportOptions.map((item) => {
                    if (item !== value) {
                        newSupportOptions.push(item)
                    }
                })
                addInfo.SupportOptions = newSupportOptions
            } else {
                addInfo.SupportOptions.push(value)
            }
            setUserEditModeForm({ ...userEditModeForm, additional_info: addInfo })
        } else {
            setUserEditModeForm({ ...userEditModeForm, [key]: value })
        }
    }

    const updateUsers = (data) => setUsers({ ...users, ...data })

    const getUsers = () => IAMAction.getUsers(profile.username, updateUsers)

    React.useEffect(() => {
        IAMAction.getRegistrationMetadata(setMetadata)
    }, [])

    React.useEffect(() => {
        if (actionStatus === 'SUCCESS') {
            setSelectedRow(userTemplate)
            setBulkActionDialog({ data: [] })
            getUsers()
        }
    }, [actionStatus])

    var column_info = [
        { name: "username", label: "Username", sort: false, searchable: true, filter: false, display: true },
        { name: "fname", label: "First Name", sort: false, searchable: true, filter: false, display: !responsive.isMobile },
        { name: "lname", label: "Last Name", sort: false, searchable: true, filter: false, display: !responsive.isMobile },
        { name: "email", label: "Email", sort: false, searchable: true, filter: false, display: !responsive.isMobile },
        { name: "company", label: "Company", sort: true, searchable: false, filter: false, display: !responsive.isMobile },
        { name: "customer", label: "Customer", sort: true, searchable: false, filter: true, display: !responsive.isMobile },
        { name: "accounttype", label: "Account Type", sort: false, searchable: false, filter: true, display: !responsive.isMobile },
        { name: "contact_number", label: "Contact Number", sort: false, searchable: false, filter: false, display: false },
        { name: "manager_name", label: "Manager Name", sort: false, searchable: false, filter: false, display: false },
        { name: "manager_email", label: "Manager Email", sort: false, searchable: false, filter: false, display: false },
        { name: "accesslvl", label: "Role", sort: false, searchable: false, filter: true, display: !responsive.isMobile },
        { name: "access", label: "Access", sort: false, searchable: false, filter: false, display: false },
        { name: "approved", label: "Approved", sort: false, searchable: false, filter: true, display: true },
        { name: "islocked", label: "Locked", sort: false, searchable: false, filter: true, display: true },
        { name: "twofactor", label: "2FA", sort: false, searchable: false, filter: true, display: !responsive.isMobile },
        { name: "last_logged_in", label: "Last Logged In", sort: false, searchable: false, filter: false, display: false },
        { name: "registration_date", label: "Registration Date", sort: false, searchable: false, filter: false, display: !responsive.isMobile },
        { name: "approval__date", label: "Approval Date", sort: false, searchable: false, filter: false, display: !responsive.isMobile },
        { name: "update_date", label: "Update Date", sort: false, searchable: false, filter: false, display: false },
    ]

    if (profile.company === "Ericsson" && ["admin", "superadmin"].includes(String(profile.accesslvl).toLowerCase())) {
        column_info = [
            { name: "username", label: "Username", sort: false, searchable: true, filter: false, display: true },
            { name: "fname", label: "First Name", sort: false, searchable: true, filter: false, display: !responsive.isMobile },
            { name: "lname", label: "Last Name", sort: false, searchable: true, filter: false, display: !responsive.isMobile },
            { name: "email", label: "Email", sort: false, searchable: true, filter: false, display: !responsive.isMobile },
            { name: "company", label: "Company", sort: true, searchable: false, filter: false, display: !responsive.isMobile },
            { name: "customer", label: "Customer", sort: true, searchable: false, filter: true, display: !responsive.isMobile },
            { name: "accounttype", label: "Account Type", sort: false, searchable: false, filter: true, display: !responsive.isMobile },
            { name: "admin", label: "Admin", sort: false, searchable: true, filter: false, display: true },
            { name: "contact_number", label: "Contact Number", sort: false, searchable: false, filter: false, display: false },
            { name: "manager_name", label: "Manager Name", sort: false, searchable: false, filter: false, display: false },
            { name: "manager_email", label: "Manager Email", sort: false, searchable: false, filter: false, display: false },
            { name: "accesslvl", label: "Role", sort: false, searchable: false, filter: true, display: !responsive.isMobile },
            { name: "access", label: "Access", sort: false, searchable: false, filter: false, display: false },
            { name: "approved", label: "Approved", sort: false, searchable: false, filter: true, display: true },
            { name: "islocked", label: "Locked", sort: false, searchable: false, filter: true, display: true },
            { name: "twofactor", label: "2FA", sort: false, searchable: false, filter: true, display: !responsive.isMobile },
            { name: "last_logged_in", label: "Last Logged In", sort: false, searchable: false, filter: false, display: false },
            { name: "registration_date", label: "Registration Date", sort: false, searchable: false, filter: false, display: !responsive.isMobile },
            { name: "approval__date", label: "Approval Date", sort: false, searchable: false, filter: false, display: !responsive.isMobile },
            { name: "update_date", label: "Update Date", sort: false, searchable: false, filter: false, display: false },
        ]
    }

    const changeRole = (checked, index, data) => {
        var allusers = users.data
        data = { ...data, accesslvl: checked ? "admin" : "user" }
        allusers[index] = data
        IAMAction.editUser({ username: data.username, accesslvl: data.accesslvl }).then((response) => {
            if (response.data.status === "SUCCESS") {
                setUsers({ ...users, data: allusers })
            }
        }).catch(console.error)
    }

    const customBodyRenderLite = (dataIndex, rowIndex, col) => {
        return (
            <React.Fragment>
                {
                    col.name === "approved" ? (
                        users.data[dataIndex][col.name] === 1 ? (
                            <CheckIcon color='secondary' />
                        ) : users.data[dataIndex][col.name] === 2 ? (
                            <CheckIcon color='secondary' />
                        ) : users.data[dataIndex][col.name] === 3 ? (
                            <DoneAllIcon color='primary' />
                        ) : users.data[dataIndex][col.name] === 0 ? (
                            <ClearIcon color='error' />
                        ) : null
                    ) : col.name === "accesslvl" ? (
                        users.data[dataIndex][col.name] === "user" ? (
                            <Tooltip title={<Typography variant='h5' color='textSecondary'>User</Typography>}><PersonIcon color='primary' /></Tooltip>
                        ) : users.data[dataIndex][col.name] === "admin" ? (
                            <Tooltip title={<Typography variant='h5' color='textSecondary'>Admin</Typography>}><PeopleIcon color='primary' /></Tooltip>
                        ) : users.data[dataIndex][col.name] === "superadmin" ? (
                            <Tooltip title={<Typography variant='h5' color='textSecondary'>Superadmin</Typography>}><SupervisorAccountIcon color='primary' /></Tooltip>
                        ) : null
                    ) : col.name === "twofactor" ? (
                        users.data[dataIndex][col.name] === 'YES' ? <Tooltip title={<Typography variant='h5' color='textSecondary'>Enabled</Typography>}><FiberManualRecordIcon color='primary' /></Tooltip> : <Tooltip title={<Typography variant='h5' color='textSecondary'>Disabled</Typography>}><FiberManualRecordIcon color='error' /></Tooltip>
                    ) : col.name === "admin" ? (
                        <Checkbox color='primary' checked={["superadmin", "admin"].includes(users.data[dataIndex]["accesslvl"])} disabled={["superadmin"].includes(users.data[dataIndex]["accesslvl"]) || users.data[dataIndex]["username"] === profile.username} onChange={(event) => changeRole(event.target.checked, dataIndex, users.data[dataIndex])} />
                    ) : col.name === "islocked" ? (
                        users.data[dataIndex][col.name] === 'YES' ? <Tooltip title={<Typography variant='h5' color='textSecondary'>Account Locked</Typography>}><LockIcon color='error' /></Tooltip> : <Tooltip title={<Typography variant='h5' color='textSecondary'>Account Unlocked</Typography>}><LockOpenIcon color='primary' /></Tooltip>
                    ) : <Typography variant='h5' color='textSecondary'>{users.data[dataIndex][col.name]}</Typography>}
            </React.Fragment>
        )
    }

    const approvalFilterOptions = {
        customFilterListOptions: { render: (value) => value === 0 ? 'Unapproved' : value === 1 ? 'Customer Approved' : value === 2 ? 'Ericsson Approved' : value === 3 ? 'Approved' : "Unknown State" },
        filterOptions: { renderValue: (value) => value === 0 ? 'Unapproved' : value === 1 ? 'Customer Approved' : value === 2 ? 'Ericsson Approved' : value === 3 ? 'Approved' : "Unknown State" },
    }

    const columns = column_info.map((col) => (
        {
            name: col.name,
            label: col.label,
            options: {
                display: col.display,
                sort: col.sort,
                searchable: col.searchable,
                filter: col.filter,
                setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap", backgroundColor: "#0A0A0C", fontSize: "1rem", fontWeight: 700 } }),
                setCellProps: () => ({ style: { fontSize: "0.9rem" } }),
                customBodyRenderLite: (dataIndex, rowIndex) => customBodyRenderLite(dataIndex, rowIndex, col),
            }
        }
    ))

    columns.map((column) => { if (column.name === 'approved') { column.options = { ...column.options, ...approvalFilterOptions } } })

    const options = {
        onTableInit: () => getUsers(),
        responsive: "standard",
        elevation: 16,
        rowsPerPage: 20,
        rowsPerPageOptions: [20, 50],
        selectableRows: !responsive.isMobile ? ['superadmin', 'admin'].includes(profile.accesslvl) ? "multiple" : "none" : "none",
        searchPlaceholder: "Username, Email, First Name, Last Name",
        download: false,
        print: false,
        viewColumns: true,
        reload: true,
        bulkAction: true,
        customToolbar: () => {
            return (
                <React.Fragment>
                    {profile.company === "Ericsson" && ["admin", "superadmin"].includes(String(profile.accesslvl).toLowerCase()) ? <Tooltip title={<Typography variant='h5' color='textSecondary'>Manage Customers</Typography>} disableFocusListener><IconButton onClick={() => setAddCustomer({ ...addCustomer, open: true })}><AddBoxRoundedIcon /></IconButton></Tooltip> : null}
                    <Tooltip title={<Typography variant='h5' color='textSecondary'>Reload Table</Typography>} disableFocusListener><IconButton style={users.status === 'WORKING' ? { animation: 'logo-spin infinite 1s linear' } : {}} onClick={() => getUsers()}><CachedIcon /></IconButton></Tooltip>
                </React.Fragment>
            )
        },
        onCellClick: (colData, cellMeata) => column_info[cellMeata.colIndex].name !== "admin" ? setSelectedRow(users.data[cellMeata.dataIndex]) : {},
        setBulkAction: setBulkActionDialog,
    };

    const CustomTableFilterList = (props) => {
        const CustomChip = ({ index, label, onDelete }) => { return <Chip variant="outlined" color="secondary" label={String(column_info[index].label) + ': ' + String(label)} onDelete={onDelete} /> }
        return <TableFilterList {...props} ItemComponent={CustomChip} />
    }

    const approveUser = () => { IAMAction.approverUser({ user: selectedRow.username }, setActionStatus) }

    const toggleLock = () => { IAMAction.toggleLock(selectedRow.username, setActionStatus) }

    const bulkApproverUser = () => { IAMAction.bulkApproverUser({ users: bulkActionDialog.data.map((item) => { return users.data[item.dataIndex].username }) }, setActionStatus) }

    const editUser = () => {
        var payload = {}
        Object.keys(userEditModeForm).map((key) => {
            if (userEditModeForm[key] !== selectedRow[key]) {
                payload = { ...payload, [key]: userEditModeForm[key] }
            }
        })
        if (Object.keys(payload).length > 0) {
            payload = { ...payload, username: userEditModeForm.username, additional_info: JSON.stringify(payload.additional_info) }
            IAMAction.editUser(payload).then((response) => {
                if (response.data.status) {
                    setSelectedRow(userEditModeForm)
                    getUsers()
                    setUserEditModeForm(userTemplate)
                    setUserEditModeOn(false)
                }
            }).catch(console.error)
        }
    }

    const reset2FA = () => { IAMAction.reset2FA(selectedRow.username).finally(() => {
        setSelectedRow(userTemplate)
        getUsers()
        setUserEditModeForm(userTemplate)
        setUserEditModeOn(false)
    }) }

    const resetPassword = () => { IAMAction.resetPassword(selectedRow.username) }

    var b2bConfig = {}
    metadata.data.b2bSupportConfig.map((b2b) => {
        if (!Object.keys(b2bConfig).includes(b2b.SupportNameDisplay)) {
            b2bConfig = { ...b2bConfig, [b2b.SupportNameDisplay]: b2b.SupportNameCode }
        }
    })

    return (
        <React.Fragment>
            <Card className={responsive.isDesktopOrLaptop ? classes.rootDesktop : responsive.isTablet ? classes.rootTablet : responsive.isMobile ? classes.rootMobile : classes.rootDesktop}>
                <CardContent>
                    <MuiThemeProvider theme={getMuiTheme}>
                        <MUIDataTable
                            key='all users'
                            title={<Typography variant='h3' color='textSecondary'>User Management</Typography>}
                            data={users.data}
                            columns={columns}
                            options={options}
                            components={{ TableFilterList: CustomTableFilterList, TableHead: MUIDataTableHead, TableToolbarSelect: MUIDataTableToolbarSelect }}
                        />
                    </MuiThemeProvider>
                </CardContent>
            </Card>
            <UserDialog open={Object.keys(selectedRow.username).length > 0} fullScreen={responsive.isMobile} fullWidth={!responsive.isMobile} maxWidth='sm'>
                <DialogTitle>
                    <Grid container direction={'row'} justify={responsive.isMobile ? 'space-between' : 'flex-start'} spacing={2}>
                        <Grid item><Typography variant='h4' color='textSecondary'>{selectedRow.fname} {selectedRow.lname}</Typography></Grid>
                        {
                            selectedRow.username !== profile.username ? (
                                responsive.isMobile ? (
                                    userEditModeOn ? (
                                        <React.Fragment>
                                            <Grid item><Tooltip title={<Typography variant='h5' color='textSecondary'>Edit User</Typography>}><IconButton className={classes.saveButtonMobile} onClick={() => editUser()}><SaveIcon color='primary' /></IconButton></Tooltip></Grid>
                                            <Grid item><Tooltip title={<Typography variant='h5' color='textSecondary'>Edit User</Typography>}><IconButton className={classes.editButtonMobile} onClick={() => {
                                                setUserEditModeOn(false)
                                                setUserEditModeForm(userTemplate)
                                            }}><BlockIcon color='secondary' /></IconButton></Tooltip></Grid>
                                        </React.Fragment>
                                    ) : (
                                        <Grid item><Tooltip title={<Typography variant='h5' color='textSecondary'>Edit User</Typography>}><span><IconButton className={classes.editButtonMobile} onClick={() => {
                                            setUserEditModeOn(true)
                                            setUserEditModeForm(selectedRow)
                                            // setUserEditModeForm({ ...selectedRow, supportNameCode: selectedRow.additional_info.SupportNameCode })
                                        }}><EditIcon color='primary' /></IconButton></span></Tooltip></Grid>
                                    )
                                ) : (
                                    userEditModeOn ? (
                                        <React.Fragment>
                                            <Grid item><Button size='small' variant='contained' color='primary' startIcon={<SaveIcon />} onClick={() => editUser()}><Typography variant='h6' color='textSecondary'>Save User</Typography></Button></Grid>
                                            <Grid item><Button size='small' variant='contained' color='primary' startIcon={<BlockIcon />} onClick={() => {
                                                setUserEditModeOn(false)
                                                setUserEditModeForm(userTemplate)
                                            }}><Typography variant='h6' color='textSecondary'>Cancel Edit</Typography></Button></Grid>
                                        </React.Fragment>
                                    ) : (
                                        <Grid item><Button size='small' variant='contained' color='primary' startIcon={<EditIcon />} onClick={() => {
                                            setUserEditModeOn(true)
                                            setUserEditModeForm(selectedRow)
                                            // setUserEditModeForm({ ...selectedRow, supportNameCode: selectedRow.additional_info.SupportNameCode })
                                        }}><Typography variant='h6' color='textSecondary'>Edit User</Typography></Button></Grid>
                                    )
                                )
                            ) : null
                        }
                        <Grid item><Tooltip title={<Typography variant='h5' color='textSecondary'>Close</Typography>}><IconButton aria-label="close" className={classes.closeButton} onClick={() => {
                            setSelectedRow(userTemplate)
                            setUserEditModeOn(false)
                            setUserEditModeForm(userTemplate)
                        }}><CloseIcon color='secondary' /></IconButton></Tooltip></Grid>
                    </Grid>
                </DialogTitle>
                <Divider style={{ backgroundColor: "#4d4d4d", marginTop: '5px', marginBottom: '5px' }} />
                <DialogContent>
                    {
                        userEditModeOn ? (
                            <Grid container direction='column' justify='flex-start' alignItems='flex-start' spacing={2}>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                                        <Grid item style={{ width: '150px' }}><Typography variant='h5' color='textSecondary'>Username:</Typography></Grid>
                                        <Grid item><Typography variant='h5' color='textSecondary'>{selectedRow.username}</Typography></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                                        <Grid item style={{ width: '150px' }}><Typography variant='h5' color='textSecondary'>Email:</Typography></Grid>
                                        <Grid item style={{ width: '350px' }}>
                                            <TextField fullWidth variant='outlined' size='small' value={userEditModeForm.email} type="email" onChange={(e) => updateUserEditModeForm("email", e.target.value)} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                                        <Grid item style={{ width: '150px' }}><Typography variant='h5' color='textSecondary'>First Name:</Typography></Grid>
                                        <Grid item style={{ width: '350px' }}>
                                            <TextField fullWidth variant='outlined' size='small' value={userEditModeForm.fname} type="text" onChange={(e) => updateUserEditModeForm("fname", e.target.value)} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                                        <Grid item style={{ width: '150px' }}><Typography variant='h5' color='textSecondary'>Last Name:</Typography></Grid>
                                        <Grid item style={{ width: '350px' }}>
                                            <TextField fullWidth variant='outlined' size='small' value={userEditModeForm.lname} type="text" onChange={(e) => updateUserEditModeForm("lname", e.target.value)} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                                        <Grid item style={{ width: '150px' }}><Typography variant='h5' color='textSecondary'>Contact Number:</Typography></Grid>
                                        <Grid item style={{ width: '350px' }}>
                                            <TextField fullWidth variant='outlined' size='small' value={userEditModeForm.contact_number} type="tel" onChange={(e) => updateUserEditModeForm("contact_number", e.target.value)} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '150px' }}><Typography variant='h5' color='textSecondary'>User Locked</Typography></Grid>
                                        <Grid item style={{ width: '350px' }}>
                                            <Select labelId="user-accounttype_chanage" id="accounttype" fullWidth value={userEditModeForm.islocked === "YES" ? 3 : userEditModeForm.islocked === "NO" ? 0 : userEditModeForm.islocked} onChange={(event) => updateUserEditModeForm("islocked", event.target.value)}>
                                                <MenuItem key="YES" value={3}>YES</MenuItem>
                                                <MenuItem key="NO" value={0}>NO</MenuItem>
                                            </Select>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                                        <Grid item style={{ width: '150px' }}><Typography variant='h5' color='textSecondary'>Account Type:</Typography></Grid>
                                        <Grid item style={{ width: '350px' }}><Select labelId="user-locking" id="company" fullWidth value={userEditModeForm.accounttype} onChange={(event) => updateUserEditModeForm("accounttype", event.target.value)}>{(metadata.data.accounttypes[userEditModeForm.customer.toLowerCase()] || metadata.data.accounttypes[""] || []).map((accounttype) => <MenuItem key={accounttype} value={accounttype}>{accounttype}</MenuItem>)}</Select></Grid>
                                    </Grid>
                                </Grid>
                                {
                                    userEditModeForm.accounttype === "B2B" ? (
                                        <React.Fragment>
                                            <Grid item>
                                                <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                                                    <Grid item style={{ width: '150px' }}><Typography variant='h5' color='textSecondary'>Support Type:</Typography></Grid>
                                                    <Grid item style={{ width: '350px' }}>
                                                        <Select labelId="user-locking" id="company" fullWidth value={userEditModeForm.additional_info.SupportNameCode} onChange={(event) => updateUserEditModeForm("supportNameCode", event.target.value)}>
                                                            <MenuItem key="UNASSIGNED" value="UNASSIGNED">Unassigned</MenuItem>
                                                            {Object.keys(b2bConfig).map((type) => <MenuItem key={b2bConfig[type]} value={b2bConfig[type]}>{type}</MenuItem>)}
                                                        </Select>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {
                                                userEditModeForm.additional_info.SupportNameCode !== "UNASSIGNED" ? (
                                                    <Grid item>
                                                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                                            <Grid item style={{ width: '150px' }}><Typography variant='h5' color='textSecondary'>Support Options:</Typography></Grid>
                                                            <Grid item style={{ width: '350px' }}>
                                                                <Grid container direction='column' justify='flex-start' alignItems='flex-start'>
                                                                    {
                                                                        metadata.data.b2bSupportConfig.map((config) =>
                                                                            userEditModeForm.additional_info.SupportNameCode === config.SupportNameCode ? (
                                                                                <Grid item>
                                                                                    <FormControlLabel
                                                                                        label={<Typography variant="h5" color="textSecondary">{config.SupportTypeDisplay}</Typography>}
                                                                                        control={
                                                                                            <CustomCheckbox
                                                                                                color="primary"
                                                                                                checked={![undefined, null].includes(userEditModeForm.additional_info.SupportOptions) ? userEditModeForm.additional_info.SupportOptions.includes(config.SupportTypeCode) : null}
                                                                                                onChange={(event) => updateUserEditModeForm("SupportOptions", config.SupportTypeCode)}
                                                                                                name={config.SupportTypeDisplay}
                                                                                            />
                                                                                        }
                                                                                    />
                                                                                </Grid>
                                                                            ) : null
                                                                        )
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                ) : null
                                            }
                                        </React.Fragment>
                                    ) : null
                                }
                            </Grid>
                        ) : (
                            <Grid container direction='column' justify='flex-start' alignItems='flex-start' spacing={2}>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>Username/Email</Typography></Grid>
                                        <Grid item style={{ width: '300px' }}><a href={'mailto:' + selectedRow.email}><Typography variant='h5' color='textSecondary'>{selectedRow.username}/{selectedRow.email}</Typography></a></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>First Name/Last Name</Typography></Grid>
                                        <Grid item style={{ width: '300px' }}><Typography variant='h5' color='textSecondary'>{selectedRow.fname}/{selectedRow.lname}</Typography></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>Contact Number</Typography></Grid>
                                        <Grid item style={{ width: '300px' }}><Typography variant='h5' color='textSecondary'>{selectedRow.contact_number}</Typography></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>Role</Typography></Grid>
                                        <Grid item style={{ width: '300px' }}><Typography variant='h5' color='textSecondary'>{selectedRow.accesslvl}</Typography></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>Company - Customer</Typography></Grid>
                                        <Grid item style={{ width: '300px' }}><Typography variant='h5' color='textSecondary'>{selectedRow.company} - {selectedRow.customer}</Typography></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>Manager</Typography></Grid>
                                        <Grid item style={{ width: '300px' }}><a href={'mailto:' + selectedRow.manager_email}><Typography variant='h5' color='textSecondary'>{selectedRow.manager_name}/{selectedRow.manager_email}</Typography></a></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>Approval Status:</Typography></Grid>
                                        <Grid item style={{ width: '300px' }}>
                                            {
                                                selectedRow.approved === 0 ? (
                                                    <Typography variant='h5' color='textSecondary'>NO</Typography>
                                                ) : selectedRow.approved === 1 ? (
                                                    <Typography variant='h5' color='textSecondary'>Awaiting for Ericsson approval</Typography>
                                                ) : selectedRow.approved === 2 ? (
                                                    <Typography variant='h5' color='textSecondary'>Awaiting for Manager approval</Typography>
                                                ) : selectedRow.approved === 3 ? (
                                                    <Typography variant='h5' color='textSecondary'>Approved</Typography>
                                                ) : null
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>User Locked</Typography></Grid>
                                        <Grid item style={{ width: '300px' }}><Typography variant='h5' color='textSecondary'>{selectedRow.islocked}</Typography></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>2FA Enabled</Typography></Grid>
                                        <Grid item style={{ width: '50px' }}><Typography variant='h5' color='textSecondary'>{selectedRow.twofactor}</Typography></Grid>
                                        {profile.username !== selectedRow.username && selectedRow.twofactor === "YES" && ["superadmin"].includes(String(profile.accesslvl).toLowerCase()) ? <Grid item><Tooltip title={"Reset 2FA"}><span><IconButton size='small' onClick={reset2FA} color='secondary'><RestoreFromTrashIcon /></IconButton></span></Tooltip></Grid> : null}
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>Account Type:</Typography></Grid>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>{selectedRow.accounttype}{![undefined, null].includes(selectedRow.additional_info) && ![undefined, null].includes(selectedRow.additional_info.SupportNameCode) ? " - " + String(selectedRow.additional_info.SupportNameCode) : ""}</Typography></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>Registration Date</Typography></Grid>
                                        <Grid item style={{ width: '300px' }}><Typography variant='h5' color='textSecondary'>{selectedRow.registration_date}</Typography></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>Approval Date</Typography></Grid>
                                        <Grid item style={{ width: '300px' }}><Typography variant='h5' color='textSecondary'>{selectedRow.approval__date}</Typography></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>Last Login Data</Typography></Grid>
                                        <Grid item style={{ width: '300px' }}><Typography variant='h5' color='textSecondary'>{selectedRow.last_logged_in}</Typography></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={1}>
                                        <Grid item style={{ width: '200px' }}><Typography variant='h5' color='textSecondary'>Update Date</Typography></Grid>
                                        <Grid item style={{ width: '300px' }}><Typography variant='h5' color='textSecondary'>{selectedRow.update_date}</Typography></Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    }
                </DialogContent>
                <Divider style={{ backgroundColor: "#4d4d4d", marginTop: '5px', marginBottom: '5px' }} />
                <DialogActions>
                    <Button variant='contained' color='primary' disabled={selectedRow.approved > 2} onClick={approveUser}><Typography variant='h5' color='textSecondary'>Approve User</Typography></Button>
                    {profile.username !== selectedRow.username && ["superadmin", "admin"].includes(String(profile.accesslvl).toLowerCase()) ? <Button variant='contained' color='primary' onClick={resetPassword}><Typography variant='h5' color='textSecondary'>Reset Password</Typography></Button> : null}
                    <Button variant='contained' color='primary' startIcon={selectedRow.islocked === "YES" ? <LockOpenIcon /> : <LockIcon />} disabled={profile.username === selectedRow.username} onClick={toggleLock}>{selectedRow.islocked === "NO" ? <Typography variant='h5' color='textSecondary'>Lock User</Typography> : <Typography variant='h5' color='textSecondary'>Unlock User</Typography>}</Button>
                </DialogActions>
            </UserDialog>
            <BulkActionDialog open={bulkActionDialog.data.length > 0} fullScreen={responsive.isMobile} fullWidth={!responsive.isMobile} maxWidth='sm' onClose={() => setBulkActionDialog({ data: [] })}>
                <DialogTitle>
                    <Grid container direction={'row'} justify={'space-between'}>
                        <Grid item><Typography variant='h4' color='textSecondary'>Bulk Actions</Typography></Grid>
                        {responsive.isMobile ? <Grid item><Tooltip title={<Typography variant='h5' color='textSecondary'>Close</Typography>}><IconButton aria-label="close" className={classes.closeButton} onClick={() => setBulkActionDialog({ data: [] })}><CloseIcon /></IconButton></Tooltip></Grid> : null}
                    </Grid>
                </DialogTitle>
                <Divider style={{ backgroundColor: "#4d4d4d", marginTop: '5px', marginBottom: '5px' }} />
                <DialogContent>
                    <Grid container direction='column' justify='flex-start' alignItems='flex-start' spacing={2}>
                        <Grid item><Typography variant='h5' color='textSecondary'>Selected Users</Typography></Grid>
                        <Grid item style={responsive.isMobile ? {} : { marginLeft: '25px' }}>
                            <Grid container direction='column' justify='flex-start' alignItems='flex-start' spacing={1}>
                                {
                                    bulkActionDialog.data.map((item) => (
                                        <Grid item><Typography variant='h5' color='textSecondary'>{users.data[item.dataIndex].username}/{users.data[item.dataIndex].email}</Typography></Grid>
                                    ))
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider style={{ backgroundColor: "#4d4d4d", marginTop: '5px', marginBottom: '5px' }} />
                <DialogActions>
                    <Button variant='contained' color='primary' onClick={bulkApproverUser}><Typography variant='h5' color='textSecondary'>Approve User</Typography></Button>
                </DialogActions>
            </BulkActionDialog>
            <Dialog open={addCustomer.open} fullScreen={responsive.isMobile} onClose={() => setAddCustomer({ open: false, customer: "", status: "NEW" })}>
                <DialogTitle>
                    <Grid container direction={'row'} justify={'space-between'}>
                        <Grid item><Typography variant='h4' color='textSecondary'>Add Company</Typography></Grid>
                        <Grid item><Tooltip title={<Typography variant='h5' color='textSecondary'>Close</Typography>}><IconButton aria-label="close" className={classes.closeButton} onClick={() => setAddCustomer({ open: false, customer: "", status: "NEW" })}><CloseIcon color='secondary' /></IconButton></Tooltip></Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <TextField variant='outlined' size='small' value={addCustomer.customer} onChange={(e) => setAddCustomer({ ...addCustomer, status: "NEW", customer: e.target.value })} />
                    {addCustomer.status === "SUCCESS" ? <Typography variant='h5' color='textSecondary'>Customer Added</Typography> : null}
                </DialogContent>
                <Divider style={{ backgroundColor: "#4d4d4d", marginTop: '5px', marginBottom: '5px' }} />
                <DialogActions>
                    <Button variant='contained' startIcon={addCustomer.status === "WORKING" ? <CachedIcon /> : null} disabled={addCustomer.status !== "NEW" || addCustomer.customer.length === 0} color='primary' onClick={() => IAMAction.addCompany(addCustomer, setAddCustomer)}><Typography variant='h5' color='textSecondary'>Add</Typography></Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default Usermanagement
